// @ts-nocheck
import { type I18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { type FC, useEffect } from 'react'

import { withI18n } from 'shared/utils/withI18n'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import Notification from 'views/components/molecules/Notification'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import scrollToTop from 'views/utils/scrollToTop'

export interface ProviderDataType {
  providerName: string
  providerURL: string
  providerURLShort: string
}

interface NotificationODSModalProps {
  providerData: ProviderDataType
  i18n: I18n
}

const NotificationODSModal: FC<NotificationODSModalProps> = ({
  providerData,
  i18n,
}) => {
  let modalProps

  useEffect(() => scrollToTop('smooth'), [])

  if (providerData) {
    modalProps = {
      title: <Trans id="general.modal.title.important" />,
      id: 'odsModal',
      children: (
        <TransWithHtml
          text={i18n._('cart.modal.ods.content', {
            provider: providerData.providerName.toUpperCase(),
            url: providerData.providerURL,
            urlShort: providerData.providerURLShort,
          })}
        />
      ),
    }
  }

  const label = providerData ? (
    <>
      <Trans id="cart.notification.product.ods" />{' '}
      <ModalShowButton
        component={ButtonAsLink}
        modalId="odsModal"
        name="show-ods-modal"
        data-clientside-hook="odsInfo"
        onClick={null}
      >
        <Trans id="general.more.information.short" />
      </ModalShowButton>
    </>
  ) : (
    <Trans id="cart.notification.product.ods" />
  )

  return (
    <div className="l-content u-padding-large--left u-padding-large--right u-padding-large--top o-Cart__notification">
      <Notification label={label} type="info" />
      {providerData && <Modal {...modalProps} />}
    </div>
  )
}

export default withI18n()(NotificationODSModal)
